export default {
  UPLOAD_FAILED: 'UPLOAD_FAILED',
  CSV_INVALID: 'CSV_INVALID',
  JOB_FAILED: 'JOB_FAILED',
  JOB_TIMEOUT: 'JOB_TIMEOUT',
  SUBMIT_FAILED: 'SUBMIT_FAILED',
}
